import React from 'react';
import { ArrowRight } from 'lucide-react';
export function ComparisonSection() {
  return <section className="py-20 bg-white px-4 border-y border-gray-100" data-id="element-24">
      <div className="max-w-3xl mx-auto text-center" data-id="element-25">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-gray-900 mb-12" data-id="element-26">
          Por qué lo demás no resolvió el problema
        </h2>

        <div className="space-y-6 mb-12" data-id="element-27">
          {[{
          title: 'Pastillas',
          desc: 'Reducen síntomas. No reentrenan el sistema nervioso.'
        }, {
          title: 'Terapia',
          desc: 'Aporta claridad mental. Pero no regula en el pico fisiológico.'
        }, {
          title: 'Meditación',
          desc: 'Requiere un nivel previo de calma para funcionar.'
        }].map((item, i) => <div key={i} className="flex items-start gap-4 p-6 bg-gray-50 rounded-xl border border-gray-100 text-left" data-id="element-28">
              <ArrowRight className="h-5 w-5 text-[#C06B6B] mt-0.5 flex-shrink-0" data-id="element-29" />
              <div data-id="element-30">
                <span className="font-bold text-gray-900" data-id="element-31">{item.title}</span>
                <span className="text-gray-600" data-id="element-32"> — {item.desc}</span>
              </div>
            </div>)}
        </div>

        <p className="text-lg text-gray-600 mb-6" data-id="element-33">
          Si sigues intentando resolver un problema corporal solo con
          herramientas mentales… El ciclo continúa.
        </p>

        <div className="relative inline-block px-10 py-8 rounded-2xl bg-gradient-to-r from-[#C4973B] via-[#D4A84C] to-[#C4973B] shadow-xl overflow-hidden" data-id="element-34">
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent animate-pulse" data-id="element-35"></div>
          <p className="relative z-10 text-xl font-bold text-white" data-id="element-36">
            La regulación empieza en el cuerpo.
          </p>
        </div>
      </div>
    </section>;
}